import styled, { css } from "styled-components";

import { colors } from "@/styles/Variants";

import { theme } from "../theme";

const { fontFamily, breakpoint } = theme;
const color = colors.bild;

const transitionTimeAndCurve = css`
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) 0ms;
`;

export const TextField = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputWrapper = styled.div`
  display: flex;
  position: relative;
  height: 48px;
`;

export const Input = styled.input<{
  error?: boolean;
  disabled?: boolean;
}>`
  width: 100%;
  padding: ${(props) => (props.error ? "12px 54px 12px 16px" : "12px 16px")};
  border: 2px solid ${(props) => (props.error ? color.red500 : color.vader100)};
  border-radius: 8px;
  color: ${(props) => (props.disabled ? color.vader100 : color.vader400)};
  font-family: ${fontFamily.gothamXNarrow};
  font-weight: normal;
  font-size: 18px;
  line-height: 130%;
  outline: none;

  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }

  &:hover,
  &:focus,
  &:active,
  &:not(:placeholder-shown) {
    border-color: ${(props) =>
      props.error
        ? color.red500
        : props.disabled
          ? color.vader100
          : color.vader400};
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    transform: translate(3px, -7px) scale(0.75);
    ${transitionTimeAndCurve};
    transition-property: transform;
  }

  /* Change autocomplete styles in webkit for chrome  */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    box-shadow: 0 0 0 1000px ${color.vader0} inset;
    -webkit-text-fill-color: ${(props) =>
      props.disabled ? color.vader100 : color.vader500};
  }
`;

export const Label = styled.label<{
  error?: boolean;
  disabled?: boolean;
}>`
  position: absolute;
  background-color: ${color.vader0};
  color: ${(props) =>
    props.error
      ? color.red500
      : props.disabled
        ? color.vader100
        : color.vader400};
  padding: 2px 4px;
  margin-left: 12px;
  font-family: ${fontFamily.gothamXNarrow};
  font-size: 18px;
  font-weight: normal;
  line-height: 130%;
  pointer-events: none;
  text-transform: uppercase;
  transform: translate(0, 12px) scale(1);
  transform-origin: top left;
  ${transitionTimeAndCurve};
  transition-property: transform;

  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const IconWrapper = styled.i`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
`;

export const ErrorMessage = styled.p<{
  error?: boolean;
}>`
  display: ${(props) => (props.error ? "flex" : "none")};
  font-family: ${fontFamily.gothamXNarrow};
  font-weight: normal;
  font-size: 12px;
  line-height: 100%;
  color: ${color.red500};
  ${transitionTimeAndCurve};
  transition-property: color, display;
  margin: 8px 12px;
`;
